// Show SKU on product pages before the dynamic SKU
document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(function () {
    const skuElement = document.querySelector(".product__sku");

    if (skuElement && !skuElement.querySelector(".sku-label")) {
      const label = document.createElement("span");
      label.className = "sku-label";
      label.textContent = "SKU: ";
      skuElement.prepend(label);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// Auto Apply Discount Codes
document.addEventListener("DOMContentLoaded", function () {
  // -----------------------------
  // 🔧 Cookie helper functions
  // -----------------------------
  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
  }

  function setCookie(name, value, days = 365) {
    const expires = "; max-age=" + (days * 86400);
    document.cookie = name + "=" + encodeURIComponent(value) + "; path=/" + expires;
  }

  function deleteCookie(name) {
    document.cookie = name + "=; path=/; max-age=0";
  }

  // -----------------------------
  // ✅ Clear cookies and flags after order completion
  // -----------------------------
  if (window.location.pathname.includes("/checkouts/") && window.location.pathname.includes("/thank_you")) {
    deleteCookie("shop_discount_code");
    deleteCookie("shop_discount_tag");
    localStorage.removeItem("shop_discount_applied");
    sessionStorage.removeItem("discount_banner_shown");
    sessionStorage.removeItem("discount_redirected");
    return;
  }

  // -----------------------------
  // 🏷️ Match customer tags (from window.customerTags)
  // -----------------------------
  const tags = window.customerTags || [];
  let discountCode = "";
  let tagUsed = "";

  if (tags.includes("Magento Group:4") || tags.includes("5% OFF")) {
    discountCode = "SAVE_5_OFF_7QJ7A2TJRHNT";
    tagUsed = "5% OFF";
  } else if (tags.includes("Magento Group:5") || tags.includes("10% OFF")) {
    discountCode = "SAVE_10_OFF_HTB80PB4RYDN";
    tagUsed = "10% OFF";
  } else if (tags.includes("Magento Group:6") || tags.includes("15% OFF")) {
    discountCode = "SAVE_15_OFF_A2H1YJS2J503";
    tagUsed = "15% OFF";
  } else if (tags.includes("Magento Group:7") || tags.includes("20% OFF")) {
    discountCode = "SAVE_20_OFF_AH6PTSV2YWND";
    tagUsed = "20% OFF";
  } else if (tags.includes("Magento Group:8") || tags.includes("25% OFF")) {
    discountCode = "SAVE_25_OFF_84EFXGDA29X9";
    tagUsed = "25% OFF";
  } else if (tags.includes("Magento Group:9") || tags.includes("35% OFF")) {
    discountCode = "SAVE_35_OFF_25HXXG34Q49B";
    tagUsed = "35% OFF";
  } else if (tags.includes("Magento Group:11") || tags.includes("30% OFF")) {
    discountCode = "SAVE_30_OFF_GCWDX670T0WV";
    tagUsed = "30% OFF";
  }

  const savedTag = getCookie("shop_discount_tag");

  // -----------------------------
  // 🔁 Apply new discount if tag changed or not set
  // -----------------------------
  if (discountCode && tagUsed !== savedTag) {
    setCookie("shop_discount_code", discountCode);
    setCookie("shop_discount_tag", tagUsed);
    localStorage.setItem("shop_discount_applied", discountCode);
    sessionStorage.setItem("discount_redirected", discountCode); // avoid re-redirecting

    const returnUrl = window.location.pathname + window.location.search;
    const redirectUrl = "/discount/" + discountCode + "?redirect=" + encodeURIComponent(returnUrl);
    window.location.href = redirectUrl;
    return;
  }

  // -----------------------------
  // 🔁 Fallback: reapply if savedDiscount exists and not yet redirected this session
  // -----------------------------
  const savedDiscount = localStorage.getItem("shop_discount_applied") || getCookie("shop_discount_code");
  const isOnDiscountPage = window.location.pathname.startsWith("/discount/");
  const isOnCheckoutPage = window.location.pathname.includes("/checkouts/");

  if (
    savedDiscount &&
    !isOnDiscountPage &&
    !isOnCheckoutPage &&
    sessionStorage.getItem("discount_redirected") !== savedDiscount
  ) {
    sessionStorage.setItem("discount_redirected", savedDiscount);

    const fallbackUrl = "/discount/" + savedDiscount + "?redirect=" + encodeURIComponent(window.location.pathname + window.location.search);
    window.location.href = fallbackUrl;
    return;
  }

  // -----------------------------
  // 🎉 Show banner (once per session, on key pages)
  // -----------------------------
  if (
    savedDiscount &&
    !sessionStorage.getItem("discount_banner_shown")
  ) {
    const path = window.location.pathname;
    const showBannerOn = ["/", "/cart"];
    const isProductPage = path.startsWith("/products/");
    const shouldShowBanner = showBannerOn.includes(path) || isProductPage;

    if (shouldShowBanner) {
      const messages = {
        SAVE_5_OFF_7QJ7A2TJRHNT: "🎉 Your 5% discount has been applied!",
        SAVE_10_OFF_HTB80PB4RYDN: "🎉 Your 10% discount has been applied!",
        SAVE_15_OFF_A2H1YJS2J503: "🎉 Your 15% discount has been applied!",
        SAVE_20_OFF_AH6PTSV2YWND: "🎉 Your 20% discount has been applied!",
        SAVE_25_OFF_84EFXGDA29X9: "🎉 Your 25% discount has been applied!",
        SAVE_30_OFF_GCWDX670T0WV: "🎉 Your 30% discount has been applied!",
        SAVE_35_OFF_25HXXG34Q49B: "🎉 Your 35% discount has been applied!",
      };

      const message = messages[savedDiscount];
      if (message) {
        const banner = document.createElement("div");
        banner.id = "discount-banner";
        banner.innerHTML = `
          <div style="position: fixed; bottom: 63px; right: 10px; background: #1e293b; color: #fff; padding: 15px 20px; border-radius: 8px; box-shadow: 0 4px 10px rgba(0,0,0,0.2); z-index: 9999; display: flex; align-items: center; font-family: sans-serif;">
            <span>${message}</span>
            <button style="margin-left: 15px; background: transparent; border: none; color: #fff; font-size: 20px; line-height: 1; cursor: pointer;">×</button>
          </div>
        `;
        document.body.appendChild(banner);

        banner.querySelector("button").addEventListener("click", () => {
          banner.remove();
        });

        sessionStorage.setItem("discount_banner_shown", "true");
      }
    }
  }
});